import { createAction, props } from '@ngrx/store';
import { StudentTransferForm } from '../models/transfer-students-form.model';
import { DeletedAccountLookup } from '../models/undeleter.model';
import { CleverAccountLookup } from '../models/clever.model';
import { TransferinatorRequest } from '../services/models/transferinator-request.model';
import { TransferinatorAccountDetailsResponse } from '../services/models/transferinator-account-details.model';
import { AccountTransferIDs } from './support.state';

//! go through all and doublec check these before PR

export const supportInit = createAction('[Support] Support Init');

// ------------------
export const transferStudentPageInit = createAction('[Support - Transferinator] - Transfer Student Page Init');
export const transferStudents = createAction(
  '[Support - Transferinator] - Transfer Students',
  props<{ model: TransferinatorRequest }>(),
);
export const transferStudentsSuccess = createAction(
  '[Support - Transferinator] - Transfer Students Success',
);
export const transferStudentsFailed = createAction(
  '[Support - Transferinator] - Transfer Students Failed',
  props<{ error: string }>(),
);
export const transferStudentReset = createAction('[Support - Transferinator] - Transfer Student Reset');
// ------------------

export const studentSearch = createAction(
  '[Support - Transferinator] Student Search',
  props<{ searchTerm: string }>(),
);

export const formSaved = createAction(
  '[Support - Transferinator] Save Student Transfer Form',
  props<{ form: StudentTransferForm }>(),
);

// ------------------
export const accountlanguageMatchValidation = createAction(
  '[Async Validators] Transferinator - Validatate Account IDs Match',
  props<AccountTransferIDs>(),
);

export const accountlanguageMatchValidationSuccess = createAction(
  '[Async Validators] Transferinator Validation Success',
  props<{ accountsMatch: boolean; fromAccount: number }>(),
);
export const accountlanguageMatchValidationFailed = createAction(
  '[Async Validators] Transferinator Validation Failed',
  props<{ error: string }>(),
);

// ------------------
export const transferinatorAccountDetails = createAction(
  '[Support - Transferinator] API Fetch Student accounts',
  props<{ accountId: number; getStudents: boolean }>(),
);

export const transferinatorAccountDetailsSuccess = createAction(
  '[Support - Transferinator] API Fetch Student accounts Success',
  props<{
    response: TransferinatorAccountDetailsResponse;
    getStudents: boolean;
    id: number;
  }>(),
);

export const transferinatorAccountDetailsFailed = createAction(
  '[Support - Transferinator] API Fetch Student accounts Failed',
  props<{ error: string }>(),
);
// ------------------

export const accountIDReset = createAction(
  '[Support - Transferinator] Account ID changed',
  props<{
    fromAccount: boolean;
    toAccount: boolean;
  }>(),
);

export const cleverSupportPageActions = {
  cleverSupportInit: createAction('[Clever Support Page] Clever Support Init'),

  userSubmittedAccountSearch: createAction(
    '[Clever Support Page] User Submitted Account Search',
    props<{ accountId: number }>(),
  ),

  userSubmittedNewCleverDetails: createAction(
    '[Clever Support Page] User Submitted New Clever Details',
    props<{ districtName: string; ssoReference: string }>(),
  ),

  userResetAccountSearch: createAction(
    '[Clever Support Page] User Reset Account Search',
  ),
};

export const cleverSupportAPIActions = {
  accountSearchSuccess: createAction(
    '[Clever Support Page] Account search success',
    props<{ result: CleverAccountLookup }>(),
  ),

  accountSearchFailure: createAction(
    '[Clever Support Page] Account search error',
    props<{ error: string }>(),
  ),

  cleverAccountUpdateSuccess: createAction(
    '[Clever Support Page] Clever Account Update Success',
  ),

  cleverAccountUpdateFailure: createAction(
    '[Clever Support Page] Clever Account Update Failure',
    props<{ error: string }>(),
  ),
};

export const undeleteSupportPageActions = {
  undeleteSupportInit: createAction(
    '[Undelete Support Page] Undelete Support Init',
  ),

  userSubmittedAccountSearch: createAction(
    '[Undelete Support Page] User Submitted Account Search',
    props<{ accountId: number }>(),
  ),

  userRequestedStudentUndelete: createAction(
    '[Undelete Support Page] User Requested Student Undelete',
    props<{ studentId: number }>(),
  ),

  userResetAccountSearch: createAction(
    '[Undelete Support Page] User Reset Account Search',
  ),
};

export const undeleteSupportAPIActions = {
  accountSearchSuccess: createAction(
    '[Undelete Support Page] Account search success',
    props<{ result: DeletedAccountLookup }>(),
  ),

  accountSearchFailure: createAction(
    '[Undelete Support Page] Account search error',
    props<{ error: string }>(),
  ),

  undeleteAccountSuccess: createAction(
    '[Undelete Support Page] Undelete Account Success',
  ),

  undeleteAccountFailure: createAction(
    '[Undelete Support Page] Undelete Account Failure',
    props<{ error: string }>(),
  ),

  studentRestoreSuccess: createAction(
    '[Undelete Support Page] Student Restore Success',
    props<{ studentId: number }>(),
  ),

  studentRestoreFailure: createAction(
    '[Undelete Support Page] Student Restore Failure',
    props<{ error: string }>(),
  ),
};
